import React, { FC } from 'react';
import { ContainerLarge as Container } from '../../components/base/grid';
import Shipment from '../../components/myPost/myShipments/shipment';
import pageWrapper from '../../hoc/pageWrapper';
import IMyShipmentsViewModel from '../../interfaces/myShipments/myShipments';

interface Props {
	page: IMyShipmentsViewModel;
}

const MyShipmentsShipment: FC<Props> = ({ page }) => {
	return (
		<Container>
			<Shipment page={page} />
		</Container>
	);
};

export default pageWrapper(MyShipmentsShipment);
